__turbopack_context__.v({
  "kpi_card_container": "KPICard-module-scss-module__0u80wG__kpi_card_container",
});
